import React, { useCallback } from 'react';
import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { Client } from './types';

type ClientPageAdminColumnRendererProps = {
  value: Client,
  rowIndex: number,
}

export const ClientPageAdminColumnRendererFactory = ({
  showModalForEdit,
  showModalForRemove,
}: {
  showModalForEdit: (entity: Client) => void,
  showModalForRemove: (data: { entityToRemove: Client, rowIndex: number }) => void,
}) => {
  const ClientPageAdminColumnRenderer: React.FC<ClientPageAdminColumnRendererProps> = ({
    value: entity,
    rowIndex,
  }: ClientPageAdminColumnRendererProps) => {
    const showEditModal = useCallback(() => {
      showModalForEdit(entity);
    }, [entity]);

    const showRemoveModal = useCallback(() => {
      showModalForRemove({ entityToRemove: entity, rowIndex });
    }, [entity, rowIndex]);

    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Client"
          onClick={showEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>

        <button
          className="cell-icon-button"
          title="Remove Client"
          onClick={showRemoveModal}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  };
  return ClientPageAdminColumnRenderer;
};
